import { FacebookShareButton } from 'react-share'

export default function FacebookShare({
  url,
  children,
}: {
  url: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <FacebookShareButton className="share-icon" url={url} style={{ width: '100%' }}>
      {children}
    </FacebookShareButton>
  )
}
